<div class="form-content-item" *ngIf="acuView || canValidateCustomIndustry || canManageFdesCalcModel">
  <div class="fdes-scope admin-tabbar">
    <div class="seve-seg">
      <button type="button" class="seve-seg__btn" *ngIf="acuView || canValidateCustomIndustry" [class.active]="tab === 'requests'" (click)="tab = 'requests'">{{ 'industrie_validation_tab_requests' | translate }}</button>
      <button type="button" class="seve-seg__btn" *ngIf="showCalcModelTab && (acuView || canManageFdesCalcModel)" [class.active]="tab === 'engine'" (click)="tab = 'engine'">{{ 'industrie_validation_tab_engine' | translate }}</button>
    </div>
  </div>

  <div class="fdes-scope" *ngIf="tab === 'requests'">
    <ng-container
      *ngIf="!isFrance"
      [ngTemplateOutlet]="franceOnly"
      [ngTemplateOutletContext]="{ title: 'industrie_validation_requests_title', subtitle: 'industrie_validation_requests_subtitle', message: 'industrie_validation_france_only_requests' }"></ng-container>
    <div class="seve-stack" *ngIf="isFrance">
      <ng-container *ngIf="!selectedDemande">
        <div class="seve-page-head">
          <div>
            <h1 class="seve-page-title">{{ 'industrie_validation_requests_title' | translate }}</h1>
            <p class="seve-page-sub">{{ 'industrie_validation_requests_subtitle' | translate }}</p>
          </div>
          <div class="admin-chips">
            <span class="seve-badge seve-badge--warn" *ngIf="pendingCount">{{ 'industrie_validation_pending_count' | translate: { n: pendingCount } }}</span>
          </div>
        </div>

        <div class="seve-table">
          <div class="seve-thead admin-req-grid">
            <div>{{ 'industrie_validation_col_plant' | translate }}</div>
            <div>{{ 'industrie_validation_col_requester' | translate }}</div>
            <div>{{ 'industrie_validation_col_type' | translate }}</div>
            <div class="seve-cell-right">{{ 'common_field_status' | translate }}</div>
          </div>
          <div class="seve-trow seve-trow--clickable admin-req-grid" *ngFor="let d of demandes" (click)="selectDemande(d)">
            <div class="seve-cell-strong">{{ d.industryDisplayName }}</div>
            <div>{{ d.requestedByEmail || d.requestedBy }}</div>
            <div>{{ d.industryCode }}</div>
            <div class="seve-cell-right">
              <span class="seve-badge seve-badge--warn" *ngIf="d.status === 'Pending'">{{ 'industrie_validation_status_pending' | translate }}</span>
              <span class="seve-badge seve-badge--success" *ngIf="d.status === 'Approved'">{{ 'industrie_validation_status_validated' | translate }}</span>
              <span class="seve-badge seve-badge--error" *ngIf="d.status === 'Rejected'">{{ 'industrie_validation_status_refused' | translate }}</span>
            </div>
          </div>
          <div class="seve-trow" *ngIf="!demandes.length">
            <div>{{ 'industrie_validation_no_pending_request' | translate }}</div>
          </div>
        </div>

        <div class="seve-page-head admin-hist-head">
          <div>
            <h2 class="seve-page-title">{{ 'industrie_validation_history_title' | translate }}</h2>
            <p class="seve-page-sub">{{ 'industrie_validation_history_subtitle' | translate }}</p>
          </div>
        </div>

        <div class="seve-table">
          <div class="seve-thead admin-hist-grid">
            <div>{{ 'industrie_validation_col_plant' | translate }}</div>
            <div>{{ 'industrie_validation_col_requester' | translate }}</div>
            <div>{{ 'industrie_validation_col_type' | translate }}</div>
            <div>{{ 'industrie_validation_col_decided_on' | translate }}</div>
            <div class="seve-cell-right">{{ 'common_field_status' | translate }}</div>
          </div>
          <div class="seve-trow seve-trow--clickable admin-hist-grid" *ngFor="let d of historique" (click)="selectDemande(d)">
            <div class="seve-cell-strong">{{ d.industryDisplayName }}</div>
            <div>{{ d.requestedByEmail || d.requestedBy }}</div>
            <div>{{ d.industryCode }}</div>
            <div class="seve-input--mono">{{ d.decisionDate || d.createDate | date: 'dd/MM/yy' }}</div>
            <div class="seve-cell-right">
              <span class="seve-badge seve-badge--success" *ngIf="d.status === 'Approved'">{{ 'industrie_validation_status_validated' | translate }}</span>
              <span class="seve-badge seve-badge--error" *ngIf="d.status === 'Rejected'">{{ 'industrie_validation_status_refused' | translate }}</span>
              <span class="seve-badge seve-badge--neutral" *ngIf="d.status === 'Cancelled'">{{ 'industrie_validation_status_cancelled' | translate }}</span>
              <span class="seve-badge seve-badge--neutral" *ngIf="d.status === 'Archived'">{{ 'industrie_validation_status_archived' | translate }}</span>
            </div>
          </div>
          <div class="seve-trow" *ngIf="!historique.length">
            <div>{{ 'industrie_validation_history_empty' | translate }}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedDemande">
        <div class="seve-page-head">
          <div class="admin-detail-head">
            <button type="button" class="seve-iconbtn" (click)="closeDemande()"><mat-icon>arrow_back</mat-icon></button>
            <h1 class="seve-page-title">{{ selectedDemande.industryDisplayName }}</h1>
            <span class="seve-badge seve-badge--warn" *ngIf="selectedDemande.status === 'Pending'">{{ 'industrie_validation_status_pending' | translate }}</span>
            <span class="seve-badge seve-badge--success" *ngIf="selectedDemande.status === 'Approved'">{{ 'industrie_validation_status_validated' | translate }}</span>
            <span class="seve-badge seve-badge--error" *ngIf="selectedDemande.status === 'Rejected'">{{ 'industrie_validation_status_refused' | translate }}</span>
          </div>
          <div class="admin-detail-actions" *ngIf="selectedDemande.status === 'Pending'">
            <button type="button" class="seve-btn seve-btn--danger" (click)="refuseDemande()"><mat-icon>close</mat-icon>{{ 'industrie_validation_refuse_btn' | translate }}</button>
            <button type="button" class="seve-btn seve-btn--primary" (click)="validateDemande()"><mat-icon>check</mat-icon>{{ 'common_btn_validate' | translate }}</button>
          </div>
        </div>

        <div class="seve-banner seve-banner--alert" *ngIf="selectedDemande.status === 'Rejected' && selectedDemande.decisionComment">
          <span class="seve-banner__ic"><mat-icon>info</mat-icon></span>
          <div>Motif du refus : {{ selectedDemande.decisionComment }}</div>
        </div>

        <div class="seve-card">
          <div class="seve-card__head">
            <span class="seve-eyebrow">{{ 'industrie_validation_eyebrow_request' | translate }}</span>
          </div>
          <div class="seve-card__body">
            <div class="seve-grid seve-grid--2 admin-detail-grid">
              <div class="seve-field">
                <label class="seve-label">{{ (selectedDemande.requestedByEmail ? 'industrie_validation_field_requester_email' : 'industrie_validation_col_requester') | translate }}</label>
                <div>
                  <a *ngIf="selectedDemande.requestedByEmail; else requesterLogin" [href]="'mailto:' + selectedDemande.requestedByEmail">{{ selectedDemande.requestedByEmail }}</a>
                  <ng-template #requesterLogin>{{ selectedDemande.requestedBy }}</ng-template>
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'industrie_validation_col_plant' | translate }}</label>
                <div class="seve-cell-strong">{{ selectedDemande.industryDisplayName }} [{{ selectedDemande.industryCode }}]</div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'industrie_validation_field_received_on' | translate }}</label>
                <div class="seve-input--mono">{{ selectedDemande.createDate | date: 'dd/MM/yy' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="seve-card">
          <div class="seve-card__head">
            <span class="seve-eyebrow">{{ 'industrie_validation_eyebrow_plant_info' | translate }}</span>
          </div>
          <div class="seve-card__body">
            <div class="seve-grid seve-grid--2 admin-detail-grid">
              <div class="seve-field">
                <label class="seve-label">{{ 'common_field_name' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.displayName.changed">{{ baseDiff.displayName.before }}</span
                  >{{ baseDiff.displayName.after }}
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'common_field_code' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.code.changed">{{ baseDiff.code.before }}</span
                  >{{ baseDiff.code.after }}
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'ref_field_family' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.family.changed">{{ baseDiff.family.before }}</span
                  >{{ baseDiff.family.after }}
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'industrie_validation_field_mobile_station' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.mobileStation.changed">{{ baseDiff.mobileStation.before }}</span
                  >{{ baseDiff.mobileStation.after }}
                </div>
              </div>
            </div>

            <div class="admin-val-section">{{ 'industrie_validation_section_address' | translate }}</div>
            <div class="seve-grid seve-grid--2 admin-detail-grid">
              <div class="seve-field">
                <label class="seve-label">{{ 'agency_field_address_line1' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.addressL3.changed">{{ baseDiff.addressL3.before }}</span
                  >{{ baseDiff.addressL3.after }}
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'agency_field_address_line2' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.addressL4.changed">{{ baseDiff.addressL4.before }}</span
                  >{{ baseDiff.addressL4.after }}
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'agency_field_address_line3' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.addressL5.changed">{{ baseDiff.addressL5.before }}</span
                  >{{ baseDiff.addressL5.after }}
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'agency_field_postal_code' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.addressPC.changed">{{ baseDiff.addressPC.before }}</span
                  >{{ baseDiff.addressPC.after }}
                </div>
              </div>
              <div class="seve-field">
                <label class="seve-label">{{ 'agency_field_city' | translate }}</label>
                <div class="admin-val">
                  <span class="admin-val__old" *ngIf="baseDiff.addressLocation.changed">{{ baseDiff.addressLocation.before }}</span
                  >{{ baseDiff.addressLocation.after }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="seve-card">
          <div class="seve-card__head">
            <span class="seve-eyebrow">{{ 'industrie_validation_eyebrow_documents' | translate }}</span>
          </div>
          <div class="seve-card__body">
            <div class="admin-files">
              <!-- excelChanged/pdfChanged: true = replaced in this request, false = kept, null = creation
                   (nothing to compare against, so no badge — everything is new by definition) -->
              <div class="admin-file">
                <span class="admin-file__ic admin-file__ic--xls"><mat-icon>description</mat-icon></span>
                <div class="admin-file__meta">
                  <div class="admin-file__name">
                    {{ selectedDemande.excelRelativePath?.split('/')?.pop() }}
                    <span class="admin-file__badge admin-file__badge--new" *ngIf="selectedDemande.excelChanged === true">{{ 'industrie_validation_file_updated' | translate }}</span>
                    <span class="admin-file__badge" *ngIf="selectedDemande.excelChanged === false">{{ 'industrie_validation_file_unchanged' | translate }}</span>
                  </div>
                  <div class="admin-file__size">{{ formatFileSize(selectedDemande.excelSizeBytes) }}</div>
                </div>
                <mat-icon class="admin-file__dl" (click)="downloadFile(selectedDemande.excelRelativePath)">download</mat-icon>
              </div>
              <div class="admin-file">
                <span class="admin-file__ic admin-file__ic--pdf"><mat-icon>picture_as_pdf</mat-icon></span>
                <div class="admin-file__meta">
                  <div class="admin-file__name">
                    {{ selectedDemande.pdfRelativePath?.split('/')?.pop() }}
                    <span class="admin-file__badge admin-file__badge--new" *ngIf="selectedDemande.pdfChanged === true">{{ 'industrie_validation_file_updated' | translate }}</span>
                    <span class="admin-file__badge" *ngIf="selectedDemande.pdfChanged === false">{{ 'industrie_validation_file_unchanged' | translate }}</span>
                  </div>
                  <div class="admin-file__size">{{ formatFileSize(selectedDemande.pdfSizeBytes) }}</div>
                </div>
                <mat-icon class="admin-file__dl" (click)="downloadFile(selectedDemande.pdfRelativePath)">download</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="fdes-scope" *ngIf="showCalcModelTab && tab === 'engine'">
    <ng-container
      *ngIf="!isFrance"
      [ngTemplateOutlet]="franceOnly"
      [ngTemplateOutletContext]="{ title: 'industrie_validation_tab_engine', subtitle: 'industrie_validation_engine_subtitle', message: 'industrie_validation_france_only_engine' }"></ng-container>
    <div class="seve-stack admin-engine" *ngIf="isFrance">
      <div class="seve-page-head">
        <div>
          <h1 class="seve-page-title">{{ 'industrie_validation_tab_engine' | translate }}</h1>
          <p class="seve-page-sub">{{ 'industrie_validation_engine_subtitle' | translate }}</p>
        </div>
      </div>

      <div class="seve-card" *ngIf="activeEngineVersion as active">
        <div class="seve-card__head">
          <span class="seve-eyebrow">{{ 'industrie_validation_active_version' | translate }}</span>
          <span class="seve-badge seve-badge--success">{{ 'industrie_validation_status_production' | translate }}</span>
        </div>
        <div class="seve-card__body">
          <div class="admin-active">
            <span class="admin-file__ic admin-file__ic--xls"><mat-icon>description</mat-icon></span>
            <div class="admin-file__meta">
              <div class="admin-file__name">{{ active.originalFileName }}</div>
              <div class="admin-file__size">
                {{ active.version }} · {{ 'industrie_validation_published_on' | translate }} {{ active.createDate | date: 'dd/MM/yyyy' }}
                <ng-container *ngIf="active.fileSize"> · {{ formatFileSize(active.fileSize) }}</ng-container>
              </div>
            </div>
            <button type="button" class="seve-btn seve-btn--neutral seve-btn--sm" (click)="downloadEngineVersion(active)"><mat-icon>download</mat-icon>{{ 'industrie_validation_download_btn' | translate }}</button>
          </div>
        </div>
      </div>

      <div class="seve-card">
        <div class="seve-card__head">
          <span class="seve-eyebrow">{{ 'industrie_validation_publish_new_version' | translate }}</span>
        </div>
        <div class="seve-card__body">
          <div class="admin-upload" (click)="attachEngineFile()">
            <input #engineFileInput type="file" accept=".xlsx" hidden (change)="onEngineFileSelected($event)" />
            <span class="admin-file__ic admin-file__ic--upload"><mat-icon>upload_file</mat-icon></span>
            <div class="admin-file__meta">
              <div class="admin-file__name">{{ engineFileName || ('industrie_validation_drop_excel_file' | translate) }}</div>
              <div class="admin-file__size">
                <ng-container *ngIf="engineChecking">{{ 'industrie_validation_engine_checking' | translate }}</ng-container>
                <ng-container *ngIf="!engineChecking && engineFile && !engineErrors.length">{{ 'industrie_validation_engine_file_valid' | translate }}</ng-container>
                <ng-container *ngIf="!engineChecking && (!engineFile || engineErrors.length)">{{ 'industrie_validation_drag_drop_hint' | translate }}</ng-container>
              </div>
            </div>
            <mat-icon class="admin-file__state" *ngIf="engineFile && !engineChecking">{{ engineErrors.length ? 'error' : 'check_circle' }}</mat-icon>
          </div>

          <div class="seve-error admin-engine-errors" *ngIf="engineErrors.length">
            <div class="admin-engine-errors__title">{{ 'industrie_validation_engine_rejected' | translate }}</div>
            <ul>
              <li *ngFor="let error of engineErrors">{{ error }}</li>
            </ul>
          </div>

          <div class="admin-publish">
            <input class="seve-input seve-input--mono" type="text" [placeholder]="'industrie_validation_version_number_placeholder' | translate" [(ngModel)]="engineVersionInput" />
            <button type="button" class="seve-btn seve-btn--primary" [disabled]="!canPublishEngine" (click)="publishEngineVersion()">
              {{ (engineChecking ? 'industrie_validation_engine_checking_btn' : enginePublishing ? 'industrie_validation_engine_publishing' : 'industrie_validation_publish_version_btn') | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="seve-card">
        <div class="seve-card__head">
          <span class="seve-eyebrow">{{ 'industrie_validation_version_history' | translate }}</span>
        </div>
        <div class="seve-card__body seve-card__body--flush">
          <div class="seve-table">
            <div class="seve-thead admin-eng-grid">
              <div>{{ 'work_inspection_project_version' | translate }}</div>
              <div>{{ 'industrie_validation_col_file' | translate }}</div>
              <div>{{ 'industrie_validation_col_published' | translate }}</div>
              <div class="seve-cell-right">{{ 'industrie_validation_col_state' | translate }}</div>
            </div>
            <div class="seve-trow admin-eng-grid" *ngFor="let v of engineVersions">
              <div class="seve-cell-code">{{ v.version }}</div>
              <div class="admin-eng-file" (click)="downloadEngineVersion(v)"><mat-icon>download</mat-icon>{{ v.originalFileName }}</div>
              <div class="seve-input--mono">{{ v.createDate | date: 'dd/MM/yy' }}</div>
              <div class="seve-cell-right">
                <span class="seve-badge seve-badge--success" *ngIf="v.isActive">{{ 'industrie_validation_state_active' | translate }}</span>
                <span class="seve-badge seve-badge--neutral" *ngIf="!v.isActive">{{ 'industrie_validation_state_archived' | translate }}</span>
              </div>
            </div>
            <div class="seve-trow" *ngIf="!engineVersions.length">
              <div>{{ 'industrie_validation_engine_no_version' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #franceOnly let-title="title" let-subtitle="subtitle" let-message="message">
  <div class="seve-stack">
    <div class="seve-page-head">
      <div>
        <h1 class="seve-page-title">{{ title | translate }}</h1>
        <p class="seve-page-sub">{{ subtitle | translate }}</p>
      </div>
    </div>
    <div class="seve-banner seve-banner--info admin-france-only">
      <span class="seve-banner__ic"><mat-icon>info</mat-icon></span>
      <div class="admin-france-only__text">{{ message | translate }}</div>
      <button type="button" class="seve-btn seve-btn--primary" (click)="switchToFrance()">{{ 'industrie_validation_switch_to_france' | translate }}</button>
    </div>
  </div>
</ng-template>
